<template>

	<label class="NS-label" :style="wrapStyleObj">
         <span class="NS-label-title">
             {{ $t(settings.translation.title) }}
        </span>
		<div class="NS-dropdown solo">

			<div class="NS-dropdown__head NS-label__input"
				 :class="{active: visualState,
                 error: settings.condition.error,
                 overflowShadow: isOverflow,
                 disabled: isDisabled
                 }"
				 :tabindex="settings.condition.tabindex"
				 @keydown="tabOpen($event)"
				 @click="visualSwitch()"
				 ref="dropdownHead"
			>
            <span class="NS-dropdown-title"
				  :class="{shadow: !isChange}"
				  ref="dropdownValue"
				  v-html="$t(selectedItemTranslate)"
			>
            </span>
			</div>


			<div class="NS-dropdown__list"
				 @click.stop=""
				 :class="{open: visualState}"
				 ref="dropListWrap"
				 :style="{maxHeight: visualState ? dropListHeight : 0}"
			>
             <span class="NS-dropdown__list--shadow"
				   :class="{show: moving.isShadow, hide: sortList.length <= 4}"
			 ></span>
				<div class="custom__scrollbar--wrap"
					 ref="scrollBarWrap"
					 :class="{ hide: sortList.length <= 4 }"
				>
					<div class="custom__scrollbar"
						 :style="{top: scrollBar.top + 'px', height: scrollBar.height + 'px'}"
						 ref="scrollBar"
						 @mousedown.prevent="behaviorScroll($event)"
					></div>
				</div>
				<ul class="NS-dropdown__list__item--wrap"
					@scroll="useScrollBar($event)"
					ref="dropList"
					:style="{width: `calc(100% + ${scrollWidth}px )`}"
					@mouseover="checkShadow($event)"
					@mouseleave="activateShadow()"
				>
					<li class="NS-dropdown__list__item"
						v-for="(item, index) in sortList"
						:key="index"
						:class="{ active: index === moving.activeIndex}"
						ref="listItem"
						@click="selectItem(item.id, item.key, item.translate)"
						@mouseover="onMouseOver($event.target)"
						@mouseleave="onMouseLeave()"
					>
                    <span class="NS-dropdown-title">
                        {{ $t(item.translate) }}
                    </span>

					</li>
				</ul>
			</div>
			<transition name="slide-fade">
                <span v-if="settings.condition.error"
					  class="NS-label__input--errormessage">
                     {{ $t(settings.translation.errorText) }}
                 </span>
			</transition>
		</div>
	</label>


</template>

<script>

	import defaultDropdown from "@/plugin/dropdownMixin";

	export default {
		data: function() {
			return {
				isChange: false,
				selectedItem: '',
				selectedItemTranslate: '',
				isOverflow: false
			}
		},
		props: [
			'settings',
			'listItems',
			'value'
		],
		computed: {
			sortList() {
				return this.listItems.sort((a, b) => a.order - b.order)
			},
			isDisabled() {
				return this.settings.condition.disabled
			}

		},
		methods: {
			tabOpen(e) {
				if (e.which === 13 && !this.isOpenTab) {
					setTimeout(() => {
						this.isOpenTab = true;
					}, 150);
					this.visualSwitch();
				}
			},

			selectItem(id, key, translate, isClick = true) {

				const data = {
					id: id,
					key: key,
					translate: translate,
					error: false
				};

				this.$emit('click', data);

				this.selectedItem = key;
				this.selectedItemTranslate = translate;
				this.isChange = true;

				if (isClick) this.visualSwitch();

				this.settings.condition.error = false;

				setTimeout(() => {
					this.checkOverflow();
				}, 200)
			},
			visualSwitch() {
				this.changeVisualSwith('listItem', this.settings.condition.isOpenStatus);
				this.lastElScroll();
			},
			lastElScroll() {
				this.initLastElScroll('listItem', this.listItems);
			},
			keyMoving(e) {
				if (this.visualState && this.isOpenTab) {
					this.initKeyMoving('listItem', this.listItems, e);
				}
				if (this.visualState && e.which === 9)
					e.preventDefault();
			},
			initHeader() {
				if (this.value && typeof this.value != null) {

					const obj = this.listItems.find(el => el.id === parseInt(this.value));
					if (obj) this.selectItem(obj.id, obj.key, obj.translate, false)
				} else {
					this.selectedItemTranslate = this.settings.translation.defaultValue;
				}

				this.checkOverflow();
			},
			checkOverflow() {
				const widthValue = this.$refs.dropdownValue.clientWidth;
				const diff = () => (this.checkContentWidth(this.$refs.dropdownHead) - widthValue) <= 10;
				this.isOverflow = diff();
			},
			checkOverflowFromItem() {
				this.$refs.listItem.forEach(el => {
					const widthValue = el.querySelector('span').clientWidth;
					const diff = () => this.checkContentWidth(el) === widthValue;
					if (diff()) el.classList.add('overflowShadow')
				})
			},
			checkContentWidth(content) {
				const computedStyleHead = getComputedStyle(content);
				return content.clientWidth
					- parseFloat(computedStyleHead.paddingRight)
					- parseFloat(computedStyleHead.paddingLeft);
			},
		},
		watch: {
			listItems() {
				this.initHeader();
				if (this.$refs.listItem) {
					this.checkOverflowFromItem();
				}
			},
			value() {
				this.initHeader();
			}
		},
		mixins: [defaultDropdown]
	}
</script>
